/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Row_CurrentInputs */

const en_users_row_current = /** @type {(inputs: Users_Row_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You`)
};

const pt_br2_users_row_current = /** @type {(inputs: Users_Row_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você`)
};

/**
* | output |
* | --- |
* | "You" |
*
* @param {Users_Row_CurrentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_row_current = /** @type {((inputs?: Users_Row_CurrentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Row_CurrentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_row_current(inputs)
	return pt_br2_users_row_current(inputs)
});